














































































































































































































import Vue from 'vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { Prop, Watch } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import StepBar from '@/modules/shared/components/panel/StepBar.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import draggable from 'vuedraggable'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import PanelContentItemDraggableCard from '@/modules/content-item/components/panel/PanelContentItemDraggableCard.vue'
import Confirm from '@/modules/common/dialog/components/shared/Confirm.vue'
import PanelContentCampaignCart from '@/modules/content-campaign/components/panel/PanelContentCampaignCart.vue'
import WarningConfirm from '@/modules/common/dialog/components/shared/WarningConfirmOld.vue'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import { PanelContentCampaignRoute } from '@/modules/content-campaign/routes/panel-content-campaign.route'
import MediaUploader from '@/modules/media/components/shared/MediaUploader.vue'
import {
  ContentCampaignStepOneGetResourceModel,
  ContentCampaignStepOneGetResourceType
} from '@/modules/content-campaign/models/content-campaign-resource.model'
import { Notification } from '@/modules/notification/classes/notification'
import { MessageType } from '@/modules/notification/models/types/message.type'
import {
  ContentItemType,
  ContentTones,
  ContentWordCount
} from '@/modules/content-item/models/content-item-resource.model'
import { PanelContentCampaignSaveCampaignUseCase } from '@/modules/content-campaign/use-cases/panel/panel-content-campaign-save-campaign.use-case'
// @ts-ignore
import { Affix } from 'vue-affix'
import { ContentItemStepOneCollection } from '@/modules/content-item/models/content-item-collection.model'
import clone from 'just-clone'
import { isValidURL } from '@/modules/shared/helpers/utils/utils'
// import PanelContentItemLatencyAlarmMessage
//   from '@/modules/content-campaign/components/panel/PanelContentItemLatencyAlarmMessage.vue'

@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'تنظیمات',
    page_sub_header: 'محتوای خود را می توانید سفارشی سازی نمایید',
    over_header: StepBar,
    over_header_props: {
      stepNow: '1',
      steps: ['تنظیمات کمپین', 'پرداخت', 'پایان ثبت سفارش']
    }
  },
  metaInfo: {
    title: 'تنظیمات'
  },
  components: {
    // PanelContentItemLatencyAlarmMessage,
    PanelContentItemDraggableCard,
    PanelContentCampaignCart,
    MediaUploader,
    WarningConfirm,
    Confirm,
    BaseSelect,
    BaseButton,
    BaseInput,
    BaseCard,
    AlertNotification,
    Heading,
    StepBar,
    draggable,
    Affix
  }
})
export default class CreatePage extends Vue {
  //stepOne
  constructor(
    private readonly routes: PanelContentCampaignRoute,
    private readonly saveCampaignUseCase: PanelContentCampaignSaveCampaignUseCase
  ) {
    super()
  }

  @Prop() contentCampaign!: ContentCampaignStepOneGetResourceType //sameAs ContentCampaignCreateResourceType
  newItem: ContentItemStepOneCollection = {
    title: '',
    main_keyword: '',
    keywords: [],
    word_count: ContentWordCount.WORD_COUNT_1000,
    content_type: ContentItemType.ARTICLE,
    tone: ContentTones.FORMAL,
    delivery_order: 0,
    description: '',
    ai_type: false
  }
  campaign: ContentCampaignStepOneGetResourceModel = this.initData

  drag = false
  confirm = false

  $refs!: {
    cartWrapper: HTMLDivElement
    affix: Affix | any
    draggableCard: PanelContentItemDraggableCard
    settingForm: QForm
  }

  //Hooks----------
  mounted() {
    this.$refs.affix.$el.style.width = this.$refs.cartWrapper.clientWidth + 'px'
    if (this.campaign.items.length === 0) this.addItem()
  }

  //Watch-----------
  @Watch('campaign.items', { deep: true })
  onOrderChange(newVal) {
    newVal.map((item, index) => (item.delivery_order = index))
  }

  //Computed----------
  get hasData() {
    return Object.keys(this.contentCampaign.data).length > 0
  }

  get payInfo() {
    return [
      {
        column: 'تعداد مقاله',
        value: this.campaign.items.length,
        unit: ' مقاله'
      },
      {
        column: 'تعداد کل کلمات',
        value: this.sumWordCounts,
        unit: ' کلمه'
      },
      // {
      //   column: 'نرخ هر کلمه',
      //   value: this.contentCampaign.word_rates.toLocaleString(),
      //   unit: 'تومان'
      // },
      {
        class: 'text-tes-red',
        column: 'جمع تخفیف',
        value: this.sumDiscount.toLocaleString(),
        unit: 'تومان'
      },
      {
        class: 'font-weight-bold',
        column: 'قابل پرداخت',
        value: this.payable,
        unit: 'تومان'
      }
    ]
  }

  get dragOptions() {
    return {
      animation: 200,
      group: 'description',
      disabled: false,
      ghostClass: 'ghost'
    }
  }

  get backUrl() {
    return this.routes.create()
  }

  get sumWordCounts() {
    return this.campaign.items.map(item => item.word_count).reduce((prev, next) => Number(prev) + Number(next), 0)
  }

  get sumPayable() {
    return this.campaign.items
      .map(item => item.word_count * ((item.ai_type) ? this.contentCampaign.ai_word_rates[item.content_type] : this.contentCampaign.word_rates[item.content_type]))
      .reduce((prev, next) => Number(prev) + Number(next), 0)
  }

  get sumDiscount() {
    return 0
  }

  get payable() {
    return this.sumPayable - this.sumDiscount
  }

  get initData(): ContentCampaignStepOneGetResourceModel {
    return {
      id: this.hasData ? this.contentCampaign.data.id : undefined,
      attachments: this.hasData ? this.contentCampaign.data.attachments : [],
      description: this.hasData ? this.contentCampaign.data.description : '',
      items: this.hasData ? clone(this.contentCampaign.data.items) : [],
      references_url: this.hasData ? this.contentCampaign.data.references_url : '',
      title: this.hasData ? this.contentCampaign.data.title : this.contentCampaign.suggested_campaign_title
    }
  }

  //Methods----------------
  addItem() {
    let newItem = clone(this.newItem)
    this.campaign.items.push(newItem)
    this.campaign.items[this.campaign.items.length - 1].delivery_order = this.campaign.items.length - 1
  }

  removeItem(id, order) {
    if (id)
      this.saveCampaignUseCase.destroyItem(this.campaign.id, id).then(deleted => {
        if (deleted == undefined) {
          //TODO an unusual way to figure
          this.campaign.items.splice(
            this.campaign.items.findIndex(item => item.id === id),
            1
          )
        }
      })
    else
      this.campaign.items.splice(
        this.campaign.items.findIndex(item => item.delivery_order === order),
        1
      )
  }

  hasSingleIdProperty(objects) {
    if (objects.filter(obj => obj.hasOwnProperty('id')).length === 1)
      return objects.filter(obj => obj.hasOwnProperty('id')).map(obj => obj.id)[0] || null
    else return false
  }

  checkValidation() {
    let counter = this.campaign.items.length
    let isValidated = true
    this.$refs.settingForm.validate().then(success => {
      if (success === false) isValidated = success
    })
    this.campaign.items.forEach((item, index) => {
      this.$refs.draggableCard[index].checkValidation().then(success => {
        if (success === false) isValidated = success
        counter--
        if (counter === 0)
          isValidated
            ? this.saveCampaign()
            : Notification.show('لطفا تمام فیلدهای اجباری را پر نمایید', MessageType.Error)
      })
    })
  }

  saveCampaign() {
    this.saveCampaignUseCase.execute(this.campaign)
  }

  saveDraft() {
    this.$refs.settingForm.validate().then(success => {
      if (success) {
        this.saveCampaignUseCase.saveDraft(this.campaign).then(() => {
          if (this.saveCampaignUseCase.isSuccess) this.campaign = this.initData
        })
      } else Notification.show('لطفا فیلدهای اجباری را پر نمایید', MessageType.Error)
    })
  }

  urlValidation(url) {
    return isValidURL(url)
  }
}
